export default __webpack_public_path__ + "static/media/kitchen3-afterG-1920w.551da9f5.avif";